import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { RootState } from '../../../app/store';
import { ConnectedProps, connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { useHistory, useRouteMatch } from 'react-router';
import {
  black,
  fontColorPrim,
  fontColorSecond,
} from '../../../assets/styledAssets/vars';
import {
  BackIcon,
  DownIcon,
  RightIcon,
  SearchIcon,
} from '../../../components/Icons/Icons.component';
import QuestionnarieService from '../../../service/Questionnarie.service';
import { Questionnaire } from '../questionnaires';
import {
  fetchListAllGroups,
  fetchListMembers,
} from '../../../service/Groups.service';
import { DataResult, process, State } from '@progress/kendo-data-query';
import { GridExpandChangeEvent } from '@progress/kendo-react-grid';
import { Gender, User } from '../../../domains/app';
import {Column, StyledTable, Wrap} from "../../../assets/styledAssets/grid";
import Button from "../../../components/Button/Button.component"
import FormField from "../../../components/FormField/FormField.component"
import {GridColumn} from "@progress/kendo-react-grid/dist/es/GridColumn";
import messages from "./messages";
import Moment from "react-moment";

const pageSize = 20;

interface MatchParams {
  questionId: string;
  languageId: string;
}

const connector = connect((state: RootState) => ({}), {});

type PropsFromRedux = ConnectedProps<typeof connector>;

const QuestionnairesDetail: FunctionComponent<PropsFromRedux> = () => {
  const intl = useIntl();
  const history = useHistory();
  const [questionnarie, setQuestionnarie] = useState<Questionnaire>();
  const { params } = useRouteMatch<MatchParams>();
  const [total, setTotal] = useState(0);
  const [gridState, setGridState] = useState<State>({
    skip: 0,
    group: [{ field: 'id' }],
    take: pageSize,
  });
  const [search, setSearch] = useState('');
  const [listGroups, setListGroups] = useState<DataResult>();

  useEffect(() => {
    QuestionnarieService.fetchQuestionnaire(
      params.questionId,
      params.languageId,
    ).then((res) => setQuestionnarie(res));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchListAllGroups(search).then((res) => {
      setTotal(res.total);
      const groupedData = process(res.items, gridState);
      groupedData.data.forEach((g) => (g.expanded = false));
      setListGroups(groupedData);
    });
    // eslint-disable-next-line
  }, []);

  const fetch = useCallback(
    (s?: string) => {
      fetchListAllGroups(s || search).then((res) => {
        setTotal(res.total);
        const groupedData = process(res.items, gridState);
        groupedData.data.forEach((g) => (g.expanded = false));
        setListGroups(groupedData);
      });
    },
    // eslint-disable-next-line
    [],
  );

  const handleChangeInput = (e: any) => {
    setSearch(e.target.value);
    fetch(e.target.value);
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    event.dataItem[event.target.props.expandField || ''] = event.value;
    const item = (event.dataItem.items || [])[0];
    if (item.user) {
      setListGroups(Object.assign({}, listGroups));
    } else {
      fetchListMembers(event.dataItem.value, 1000, 0).then((res) => {
        res.items.forEach((u) => (u.checked = false));
        event.dataItem.items = res.items.map((user) => {
          const clonedItem = Object.assign({}, item);
          clonedItem.user = user;
          return clonedItem;
        });
        event.dataItem.items = event.dataItem.items.length
          ? event.dataItem.items
          : [item];
        setListGroups(Object.assign({}, listGroups));
      });
    }
  };

  const cellRender = (td: any, props: any) => {
    if (td && td.props.children && props.rowType === 'groupHeader') {
      const expandClick = td.props.children.props.children[0].props.onClick;
      let children = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            className="k-checkbox"
            onChange={() => toggleCheckGroup(props.dataItem)}
            checked={props.dataItem.checked}
          />
          <div
            style={{ marginLeft: '24px', display: 'flex' }}
            onClick={expandClick}
          >
            {props.expanded ? (
              <DownIcon color={'#000'} width={'2rem'} />
            ) : (
              <RightIcon color={'#000'} width={'2rem'} />
            )}
            <span style={{ marginLeft: '24px' }}>
              {props.dataItem.items[0].name}
            </span>
          </div>
        </div>
      );
      return React.cloneElement(td, td.props, children);
    }
    return td;
  };

  const toggleCheckGroup = (dataItem: any) => {
    dataItem.checked = !dataItem.checked;
    const item = (dataItem.items || [])[0];
    if (!item.user) {
      fetchListMembers(dataItem.value, 1000, 0).then((res) => {
        res.items.forEach((u) => (u.checked = true));
        dataItem.items = res.items.map((user) => {
          const clonedItem = Object.assign({}, item);
          clonedItem.user = user;
          return clonedItem;
        });
        dataItem.items = dataItem.items.length ? dataItem.items : [item];
        setListGroups(Object.assign({}, listGroups));
      });
    } else {
      dataItem.items.forEach((it: any) => {
        it.user.checked = dataItem.checked;
      });
      setListGroups(Object.assign({}, listGroups));
    }
  };

  const toggleCheckUser = (user: User) => {
    setListGroups((list) => {
      list?.data.forEach((group) => {
        group.items.forEach((g: any) => {
          if (g.user?.id === user.id) {
            g.user.checked = !g.user.checked;

            group.checked = group.items.every((g: any) => g.user.checked);
          }
        });
      });
      return Object.assign({}, list);
    });
  };

  const selectedUsers = useMemo(() => {
    const result: User[] = [];
    listGroups?.data.forEach((group) => {
      group.items.forEach((g: any) => {
        if (g.user?.checked) {
          result.push(g.user);
        }
      });
    });
    return result;
  }, [listGroups]);

  const sendQuestionnaires = () => {
/*    const requestArray: any[] = selectedUsers.map((u) => ({
      userId: u.id,
      spaceId: 'insert Space id',
    }));*/
  };

  return (
    <>
      <Wrap flexDir={'column'} width={'100%'}>
        <Wrap alignItems={'center'} width={'100%'}>
          <Column lg={45} flexCol>
            <Wrap
              fs={'1.4rem'}
              color={fontColorSecond}
              alignItems={'flex-end'}
              padding={'0 0 .5rem 4rem'}
            >
              {intl.formatMessage(messages.sendInvite)}
            </Wrap>
            <Wrap
              margin={'0 1rem 0 -1rem'}
              alignItems={'center'}
              onClick={() => history.push('/questionnaires')}
              style={{ cursor: 'pointer' }}
            >
              <Button
                icon
                transparent
                children={<BackIcon color={'#000'} width={'2rem'} />}
              />
              <Wrap
                fs={'3.2rem'}
                fw={'bold'}
                color={'#000'}
                alignItems={'flex-end'}
              >
                {questionnarie?.name}
              </Wrap>
            </Wrap>
          </Column>
          <Column lg={55}>
            <Wrap justifyCont={'flex-end'}>
              <Wrap alignItems={'center'}>
                <Wrap
                  fs={'1.6rem'}
                  color={fontColorSecond}
                  margin={'0 1.6rem 0 0'}
                >
                  {intl.formatMessage(messages.youHaveSelected)}:
                  <Wrap fs={'1.6rem'} color={black} margin={'0 0 0 0.5rem'}>
                    <strong>
                      {selectedUsers.length}{' '}
                      {intl.formatMessage(messages.members)}
                    </strong>
                  </Wrap>
                </Wrap>
                <Button primary onClick={sendQuestionnaires()}>
                  {intl.formatMessage(messages.sendQuestionnaires)}
                </Button>
              </Wrap>
            </Wrap>
          </Column>
        </Wrap>
        <Wrap alignItems={'center'} margin={'4rem 0 3rem 0'} width={'100%'}>
          <Column lg={30}>
            <FormField
              placeholder={'Search'}
              onChange={handleChangeInput}
              postfix={<SearchIcon color={fontColorPrim} width={'2rem'} />}
            />
          </Column>
        </Wrap>
      </Wrap>
      <Wrap
        grow={'1'}
        padding={'0 1.5rem'}
        overflow={'hidden'}
        width={'100%'}
        height={'100%'}
      >
        <StyledTable
          style={{ height: '100%' }}
          data={listGroups}
          onPageChange={(event) =>
            setGridState({ ...gridState, skip: event.page.skip })
          }
          {...gridState}
          expandField="expanded"
          onExpandChange={expandChange}
          total={total}
          rowHeight={55}
          selectedField="checked"
          cellRender={cellRender}
        >
          <GridColumn
            field="checked"
            width={'50px'}
            headerCell={() => <div />}
            cell={(props) =>
              props.rowType === 'groupHeader' ? (
                <></>
              ) : props.dataItem.user ? (
                <td>
                  <input
                    type="checkbox"
                    className="k-checkbox"
                    onChange={() => toggleCheckUser(props.dataItem.user)}
                    checked={props.dataItem.user?.checked}
                  />
                </td>
              ) : (
                <td
                  style={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'unset',
                    overflow: 'unset',
                  }}
                >
                  {intl.formatMessage(messages.emptyGroup)}
                </td>
              )
            }
          />
          <GridColumn
            field="user.firstName"
            title={intl.formatMessage(messages.fName)}
          />
          <GridColumn
            field="user.lastName"
            title={intl.formatMessage(messages.lName)}
          />
          <GridColumn
            field="user.gender"
            title={intl.formatMessage(messages.sex)}
            cell={(props) => {
              return props.dataItem.user ? (
                <td>
                  {props.dataItem.user?.gender === Gender.Male
                    ? intl.formatMessage(messages.male)
                    : intl.formatMessage(messages.female)}
                </td>
              ) : (
                <></>
              );
            }}
          />
          <GridColumn
            field="birth"
            title={intl.formatMessage(messages.birth)}
            width={'150px'}
            cell={(props) =>
              props.dataItem.user ? (
                <td>
                  <Moment format={'DD MMM YYYY'}>
                    {props.dataItem.owner?.birthDate}
                  </Moment>
                </td>
              ) : (
                <></>
              )
            }
          />
          <GridColumn
            field="user.email"
            title={intl.formatMessage(messages.email)}
          />
          <GridColumn
            field="user.phone"
            title={intl.formatMessage(messages.phNumber)}
            width={'130px'}
          />
        </StyledTable>
      </Wrap>
    </>
  );
};

export default connector(QuestionnairesDetail);
